import '../../css/Logo.css';

const Logo = ({ onClick, showRetry, children}) => 
	<header
		className="logo-container clickable"
		onClick={onClick}
	>
		<p id="warning">
			Updated for 2026/27!
		</p>
		<h1 id="pageLogo">
			{children.split(" ").map((word, index) => 
				<span key={word} className={index === 1 ? `puzzle-font` : 'normal-font'}>{word} </span>
			)}
		</h1>
		<p id="pageSubtitle">
			<i>{showRetry.length > 0 ? "Click here to start from scratch" : "Find partner schools for your SET Allocation Hours"}</i>
		</p>
	</header>
	

export default Logo;